export default __webpack_public_path__ + "static/media/adoption-center-pet.df41b60b.jpg";